import classNames from 'classnames';
import { useFormikContext } from 'formik';
import { useState } from 'react';
import { CollectionPointSearchParams, CollectionPointWithI18nKey } from '../../../types/collectionPoints';
import { config } from '../../../utils/config';
import { getInitialSearchParams, useGoogleMapsSdk } from '../../../utils/googleMaps';
import Overview from './Overview';
import { ViewOption } from './Overview/ViewOptions';
import './style.scss';

const CollectionPoints = ({ isStorePickup }: { isStorePickup: boolean }) => {
  const [results, setResults] = useState<CollectionPointWithI18nKey[]>([]);
  const [searchParams, setSearchParams] = useState<CollectionPointSearchParams>(getInitialSearchParams());
  const [view, setView] = useState<ViewOption>(config.collectionPoints.preferredView);
  const isMapView = view === 'map';
  const { setFieldValue, values } = useFormikContext<any>();

  const isGoogleMapsSdkLoaded = useGoogleMapsSdk();

  const onSelect = (id: string) => {
    const { carrierKey, carrierGroupKey, shippingOptionKey, collectionPointType, deliveryOptionKey } = results!.find(
      location => location.specification.collectionPointId === id
    )!.deliveryOption;
    setFieldValue('collectionPoint.id', id);
    setFieldValue('collectionPoint.type', {
      carrierKey,
      carrierGroupKey,
      shippingOptionKey,
      collectionPointType,
      deliveryOptionKey
    });
  };

  const selectedLocation = results?.find(
    location => values.collectionPoint.id === location.specification.collectionPointId
  );

  const onBackButtonClick = () => {
    setFieldValue('collectionPoint.id', '');
    setFieldValue('collectionPoint.type', {
      carrierGroupKey: '',
      carrierKey: '',
      shippingOptionKey: '',
      collectionPointType: '',
      deliveryOptionKey: ''
    });
  };

  return (
    <div
      className={classNames('collection-points', {
        'collection-points--list-view': !isMapView && !selectedLocation,
        'collection-points--with-location-details': !!selectedLocation
      })}
      data-test-id={`collection-points${selectedLocation ? '-with-location-details' : ''}`}
    >
      <Overview
        searchParams={searchParams}
        setSearchParams={setSearchParams}
        results={selectedLocation ? [selectedLocation] : results}
        setResults={setResults}
        onSelect={onSelect}
        view={view}
        setView={setView}
        isStorePickup={isStorePickup}
        isGoogleMapsSdkLoaded={isGoogleMapsSdkLoaded}
        isDetailView={!!selectedLocation}
        onBackButtonClick={onBackButtonClick}
      />
    </div>
  );
};

export default CollectionPoints;
